module.exports = __webpack_public_path__ + "static/img/icon_s7.ea50298.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_s7.png
// module id = enXD
// module chunks = 21